const COMPONENT_NAME = "TextField";
const COUNTDOWN_START_ANNOUNCE_LIMIT = 30;
export {
  COMPONENT_NAME,
  COUNTDOWN_START_ANNOUNCE_LIMIT
};
